var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"elementRef",staticClass:"scroll-reveal reveal",class:{ 'reveal--visible': _vm.isVisible }},[_vm._t("default",null,{"visible":_vm.isVisible})],2)}
var staticRenderFns = []

export { render, staticRenderFns }